export default __webpack_public_path__ + "static/media/starabc.2751044e.png";